import { Injectable } from "@angular/core";
import {
  Camera,
  CameraDirection,
  CameraResultType,
  CameraSource,
} from "@capacitor/camera";
import { Observable, from, map, of, tap } from "rxjs";
import { PhotoCapacitorUtils } from "./photo-capacitor.utils";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class TakePhotoCameraCapacitor {
  constructor(private translateService: TranslateService) {}

  /** 
   Takes a photo using the browser's camera
   @returns the photo url taken
  **/
  execute(): Observable<string> {
    return from(
      Camera.getPhoto({
        source: CameraSource.Camera,
        resultType: CameraResultType.Base64,
        direction: CameraDirection.Front,
        height: PhotoCapacitorUtils.UPLOAD_IMAGE_HEIGHT_PX,
        width: PhotoCapacitorUtils.UPLOAD_IMAGE_WIDTH_PX,
      })
    ).pipe(
      map((image) =>
        PhotoCapacitorUtils.base64DataToBase64WithFormat(
          image.base64String ?? "",
          image.format
        )
      ),
      tap((image) => {
        if (!PhotoCapacitorUtils.isLessThanMaxSize(image)) {
          throw new Error(
            `${this.translateService.instant("avatar.image-too-heavy")} ${PhotoCapacitorUtils.MAX_IMAGE_SIZE_IN_MB} MB`
          );
        }
      })
    );
  }
}
